import React, { useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	Typography,
	Button,
	Backdrop,
	makeStyles,
	Box,
	TextField
} from "@material-ui/core";
import { modalKindOptionsEnum } from "../ModalKindOptionsEnum";
import { MutantApiService } from "../../../../../services/MutantApiService";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";

const crypto = require("crypto");

const useStyles = makeStyles(theme => ({
	backdrop: {
		backdropFilter: "blur(3px)"
	}
}));

export function VoiceModelsFormModal(props) {
	const classes = useStyles();
	const { showModal, setShowModal, id, kind } = props;
	const [challengeResponse, setChallengeResponse] = useState("");
	const [challenge, setChallenge] = useState(generateRandomString());
	const [isChallengeCorrect, setIsChallengeCorrect] = useState(false);
	const api = new MutantApiService();
	const history = useHistory();
	const options = {
		delete: "Remover",
		activate: "Ativar",
		deactivate: "Desativar"
	};

	function getResultMessage(options, kind) {
		let resultMessage = "";
		switch (options[kind]) {
			case "Remover":
				resultMessage = "removido";
				break;
			case "Ativar":
				resultMessage = "ativado";
				break;
			case "Desativar":
				resultMessage = "desativado";
				break;
			default:
				break;
		}
		return resultMessage;
	}

	const handleClose = () => {
		setChallenge(generateRandomString());
		setChallengeResponse("");
		setIsChallengeCorrect(false);
		setShowModal(false);
		history.push("/dashboard/models");
	};

	const validateChallengeResponse = (response, correctResponse) => {
		return response === correctResponse;
	};

	function generateRandomString() {
		return crypto.randomBytes(4).toString("hex");
	}

	const submit = async () => {

		const currentIsChallengeCorrect = validateChallengeResponse(
				challengeResponse,
				challenge
			);
			setIsChallengeCorrect(currentIsChallengeCorrect);
	
			if (currentIsChallengeCorrect) {
				let url = `/models/${id}`;
				const method =
					props.kind === modalKindOptionsEnum.delete ? "DELETE" : "PATCH";
				let data = {};
				if (method === "PATCH") {
					url += `/toggle`;
				}
	
				const result = await api.makeHttpRequest({
					method,
					url,
					data
				});
	
		
					let resultMessage = getResultMessage(options, kind);
					Swal.fire({
						title: "Sucesso",
						text: `Solicitação de carregamento do modelo ${resultMessage} efetuada!`,
						icon: "success",
						showCancelButton: false,
						confirmButtonColor: "#9036F7"
					}).then(_result => {
						handleClose();
					});
			} else {
				console.info("Resposta do desafio incorreta");
			}
		
	};

	return (
		<Dialog
			open={showModal}
			onClose={handleClose}
			BackdropComponent={Backdrop}
			BackdropProps={{ invisible: false, className: classes.backdrop }}
			container={document.body}
			maxWidth="lg"
		>
			<DialogTitle>
				<Typography variant="h6">{options[kind]} Modelo</Typography>
			</DialogTitle>
			<DialogContent>
				<Typography variant="body1">ID: {id}</Typography>
				<Typography variant="body1">Nome: {props.name}</Typography>
				<Typography variant="body1">
					Você tem certeza que deseja {options[kind].toLowerCase()} este modelo?
				</Typography>
				<Typography
					variant="body1"
					style={{
						"-webkit-touch-callout": "none",
						"-webkit-user-select": "none",
						"-khtml-user-select": "none",
						"-moz-user-select": "none",
						"-ms-user-select": "none",
						"user-select": "none",
						fontWeight: "bold",
						marginTop: "1rem",
						display: "flex"
					}}
				>
					Digite
					<Typography
						style={{
							color: "#a7281f",
							marginLeft: "0.5rem",
							marginRight: "0.5rem",
							fontWeight: "bold"
						}}
						variant="body1"
					>
						{challenge}
					</Typography>
					na caixa abaixo para confirmar
				</Typography>
				<TextField
					label="Resposta do Desafio"
					variant="outlined"
					fullWidth
					value={challengeResponse}
					style={{ marginTop: "1rem" }}
					onChange={e => {
						setChallengeResponse(e.target.value);
						setIsChallengeCorrect(
							validateChallengeResponse(e.target.value, challenge)
						);
					}}
					onKeyPress={e => {
						if (e.key === "Enter" && isChallengeCorrect) {
							submit();
						}
					}}
					error={!isChallengeCorrect}
					helperText={!isChallengeCorrect && "Resposta do desafio incorreta"}
				/>
			</DialogContent>
			<Box
				m={2}
				display="flex"
				justifyContent="space-between"
				alignItems="center"
				flexWrap="wrap"
			>
				<Button
					onClick={submit}
					color="primary"
					style={{
						backgroundColor: isChallengeCorrect ? "#a7281f" : "#afa09f",
						color: "#fff"
					}}
					disabled={!isChallengeCorrect}
				>
					{options[kind]}
				</Button>
				<Button
					onClick={handleClose}
					color="primary"
					style={{
						backgroundColor: "#007406",
						color: "#fff"
					}}
				>
					Cancelar
				</Button>
			</Box>
		</Dialog>
	);
}

export default VoiceModelsFormModal;
